<template>
  <div>
    <!-- Modal -->
    <div id="modal_aside_mapa" class="modal fixed-left fade" role="dialog">
      <div class="modal-dialog modal-dialog-aside" role="document">
        <div class="modal-content">
          <div class="modal-header bg-geogo pt-1 pb-1">
            <h3 style="font-size: 16px" class="modal-title text-white">
              <b>Opciones Mapa</b>
            </h3>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- Tipo Entidad -->
            <div class="row">
              <div class="form-group col-md-6">
                <label for="type_entidad">Tipo Entidad</label>
                <v-select
                  :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                  v-model="type_entidad"
                  @input="selectTipoEntidad()"
                  placeholder="Tipo Entidad"
                  label="descripcion"
                  :options="listasForms.type_entidad"
                ></v-select>
              </div>
              <div class="form-group col-md-6">
                <label for="viaje_id"># Viaje</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  id="viaje_id"
                  placeholder="# Viaje"
                  v-model="filter.viaje_id"
                  :disabled="
                    !filter.type_entidad || filter.type_entidad == 'null'
                  "
                />
              </div>
            </div>
            <!-- Empresas -->
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="empresa">Empresa</label>
                  <v-select
                    :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                    placeholder="Razon Social"
                    v-model="empresa"
                    label="razon_social"
                    @search="buscarEmpresas"
                    :options="listasForms.empresas"
                    @input="selectEmpresa()"
                  ></v-select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="vehículo">Vehículo</label>
                  <v-select
                    :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                    v-model="filter.vehiculo"
                    placeholder="Placa"
                    taggable
                    multiple
                  ></v-select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="Ruta">Ruta Tramo</label>
                  <v-select
                    :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                    v-model="rutas_tramo"
                    label="nombre"
                    :options="listasForms.rutas_tramo"
                    @search="buscarRutasTramo"
                    @input="selectRutaTramo()"
                    placeholder="Ruta Tramo"
                    multiple
                  ></v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
              <i class="fas fa-times"></i>
            </button>
            <button
              type="button"
              class="btn btn-dark"
              @click="limpiarFiltros()"
            >
              Limpiar
              <i class="fas fa-trash"></i>
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="$parent.showCarros()"
            >
              Buscar
              <i class="fas fa-search"></i>
            </button>
            <button
              v-if="
                ($parent.form.carrosAct ||
                  $parent.form.carrosInact ||
                  $parent.form.carrosPost) &&
                $parent.$store.getters.can('hidrocarburos.mapas.excelVehiculos')
              "
              type="button"
              class="btn bg-indigo text-white mr-2 align-top py-1"
              style="cursor: pointer"
              @click="generarListadoExcel()"
            >
              <i style="font-size: 21px" class="far fa-file-excel"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";

export default {
  name: "MapasOptions",
  components: {
    vSelect,
  },
  data() {
    return {
      listasForms: {
        rutas_tramo: [],
        type_entidad: [],
        empresas: [],
      },
      filter: {
        type_entidad: null,
        viaje_id: null,
        empresa_id: null,
        vehiculo_id: [],
        vehiculo: [],
        ruta_id: [],
        conductor_id: null,
      },
      capasOverlays: {
        rutas: { polilineas: [] },
      },
      type_entidad: {},
      vehiculos: [],
      conductor: {},
      empresa: {},
      ruta: null,
      rutas_tramo: [],
    };
  },

  methods: {
    escHtmlInfo(s) {
      if (s == null || s === "") return "";
      return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },

    formatHoraInfo(t) {
      if (t == null || t === "") return "—";
      const s = String(t);
      if (s.length >= 16 && s.includes(" ")) {
        return s.slice(11, 16);
      }
      if (s.length >= 5 && s.indexOf(":") >= 0) {
        return s.slice(0, 5);
      }
      return s;
    },

    labelDiaSemanaInfo(d) {
      if (d == null || d === "") return "—";
      const n = parseInt(d, 10);
      const labels = ["—", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
      if (Number.isFinite(n) && n >= 1 && n <= 7) {
        return labels[n];
      }
      return this.escHtmlInfo(d);
    },

    textoVelMaxInfo(tramo) {
      const v = tramo && (tramo.vel_max ?? tramo.velMax);
      if (v == null || String(v).trim() === "") {
        return null;
      }
      const s = String(v).trim();
      if (/^\d+(\.\d+)?$/.test(s)) {
        return `${s} km/h`;
      }
      return this.escHtmlInfo(s);
    },

    /**
     * Ventana de mapa al hacer clic en la polilínea del tramo (velocidad + horarios).
     */
    htmlInfoVentanaTramo(nombreRuta, tramo) {
      const r = this.escHtmlInfo(nombreRuta || "Ruta");
      const t = this.escHtmlInfo((tramo && (tramo.nombre || tramo.Nombre)) || "Tramo");
      const velTxt = this.textoVelMaxInfo(tramo);
      const dist = tramo && (tramo.distancia_km ?? tramo.distanciaKm);
      const distTxt =
        dist != null && String(dist).trim() !== ""
          ? this.escHtmlInfo(String(dist).trim()) + " km"
          : null;

      const horariosRaw = (tramo && (tramo.horarios || tramo.Horarios)) || [];
      const horarios = Array.isArray(horariosRaw) ? horariosRaw : [];

      let filasHorario = "";
      if (horarios.length === 0) {
        filasHorario = `<tr><td colspan="3" style="padding:10px 8px;color:#64748b;font-size:12px;">Sin horarios registrados para este tramo.</td></tr>`;
      } else {
        horarios.forEach((h) => {
          const dia = this.labelDiaSemanaInfo(h.dia_semana ?? h.diaSemana);
          const hi = this.formatHoraInfo(h.horario_ini ?? h.horarioIni);
          const hf = this.formatHoraInfo(h.horario_fin ?? h.horarioFin);
          const obs = h.observacion;
          const obsEsc = obs ? this.escHtmlInfo(obs) : "";
          filasHorario += `<tr style="border-top:1px solid #e2e8f0;">
            <td style="padding:8px;font-weight:600;color:#0f172a;font-size:12px;">${dia}</td>
            <td style="padding:8px;font-size:12px;color:#334155;">${this.escHtmlInfo(hi)} – ${this.escHtmlInfo(hf)}</td>
            <td style="padding:8px;font-size:11px;color:#64748b;">${obsEsc || "—"}</td>
          </tr>`;
        });
      }

      const chipVel = velTxt
        ? `<span style="display:inline-block;background:#ecfdf5;color:#065f46;padding:6px 12px;border-radius:999px;font-size:13px;font-weight:600;border:1px solid #a7f3d0;">Vel. máx. ${this.escHtmlInfo(velTxt)}</span>`
        : `<span style="display:inline-block;background:#f1f5f9;color:#475569;padding:6px 12px;border-radius:999px;font-size:12px;">Vel. máx. no definida</span>`;
      const chipDist = distTxt
        ? `<span style="display:inline-block;margin-left:8px;background:#eff6ff;color:#1e40af;padding:6px 12px;border-radius:999px;font-size:12px;font-weight:600;border:1px solid #bfdbfe;">Dist. ${distTxt}</span>`
        : "";

      return `<div style="font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;min-width:260px;max-width:320px;border-radius:12px;overflow:hidden;box-shadow:0 8px 24px rgba(15,23,42,0.12);">
        <div style="background:linear-gradient(135deg,#047857,#059669);color:#fff;padding:12px 14px;">
          <div style="font-size:11px;opacity:0.9;letter-spacing:0.02em;">${r}</div>
          <div style="font-size:16px;font-weight:700;margin-top:4px;line-height:1.25;">${t}</div>
        </div>
        <div style="padding:12px 14px;background:#fff;">
          <div style="margin-bottom:12px;display:flex;flex-wrap:wrap;align-items:center;">${chipVel}${chipDist}</div>
          <div style="font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:6px;">Horarios permitidos</div>
          <table style="width:100%;border-collapse:collapse;font-size:12px;">
            <thead>
              <tr style="background:#f8fafc;color:#475569;">
                <th style="text-align:left;padding:6px 8px;border-radius:6px 0 0 0;">Día</th>
                <th style="text-align:left;padding:6px 8px;">Horario</th>
                <th style="text-align:left;padding:6px 8px;border-radius:0 6px 0 0;">Nota</th>
              </tr>
            </thead>
            <tbody>${filasHorario}</tbody>
          </table>
        </div>
      </div>`;
    },

    selectEmpresa() {
      this.filter.empresa_id = null;
      if (this.empresa) {
        this.filter.empresa_id = this.empresa.id;
      }
    },

    selectRutaTramo() {
      if (this.rutas_tramo && this.rutas_tramo.length) {
        this.filter.ruta_tramo_id = this.rutas_tramo.map((e) => e.id);
        this.dibujarRutasPorTramos(this.rutas_tramo);
      } else {
        this.filter.ruta_tramo_id = [];
        this.$emit("update-rutas-polylines", {});
      }
    },

    generarListadoExcel() {
      this.$parent.cargando = true;
      const filters = {
        ...this.filter,
        type_bloque: this.$parent.form.type_bloque ?? null,
        bloque_id: this.$parent.form.bloque_id ?? null,
        filtro_bloques_tep: this.$parent.form.filtro_bloques_tep === true,
        filtro_bloques_tif: this.$parent.form.filtro_bloques_tif === true,
      };
      filters.carrosAct = this.$parent.form.carrosAct;
      filters.carrosInact = this.$parent.form.carrosInact;
      filters.carrosPost = this.$parent.form.carrosPost;
      filters.carrosViajes = this.$parent.form.carrosViajes;
      filters.carrosGuias = this.$parent.form.carrosGuias;
      filters.carrosTickets = this.$parent.form.carrosTickets;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/mapas/export",
        data: { filtros: filters },
      })
        .then((response) => {
          let data = response.data;
          this.$parent.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },

    validaFechas() {
      // Se valida que la fecha inicial sea menor que la fecha final
      if (this.filter.fecha_inicio > this.filter.fecha_fin) {
        this.filter.fecha_fin = null;
        this.$swal({
          icon: "error",
          title: `La fecha inicio no puede ser mayor a la fecha fin...`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    limpiarFiltros() {
      this.filter = {
        type_entidad: null,
        viaje_id: null,
        empresa: null,
        vehiculo_id: [],
        vehiculo: [],
        ruta_id: [],
        conductor_id: null,
      };
      this.type_entidad = {};
      this.vehiculos = [];
      this.conductor = {};
      this.empresa = {};
      this.rutas_tramo = [];
      this.$emit("update-rutas-polylines", {});
      if (this.$parent && Object.prototype.hasOwnProperty.call(this.$parent, "mapQuickPlaca")) {
        this.$parent.mapQuickPlaca = "";
      }
    },

    buscarRutasTramo(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url =
          "/api/admin/centralTrafico/rutasTramosMapaCalor?nombre=" + search;
        axios
          .get(url)
          .then(function (response) {
            me.listasForms.rutas_tramo = response.data.data;
            loading(false);
          })
          .catch(function (error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    /**
     * Igual que en MapaIndex: waypoints JSON → det segmentos → recta.
     */
    pathTramoParaMapa(tramo) {
      if (!tramo) return [];

      const rawWp = tramo.waypoints;
      if (rawWp) {
        let pts;
        try {
          pts = typeof rawWp === "string" ? JSON.parse(rawWp) : rawWp;
        } catch (e) {
          pts = null;
        }
        if (Array.isArray(pts) && pts.length >= 2) {
          const pathWp = [];
          pts.forEach((p) => {
            const lat = parseFloat(p.lat ?? p.latitude);
            const lng = parseFloat(p.lng ?? p.lon ?? p.longitude);
            if (Number.isFinite(lat) && Number.isFinite(lng)) {
              pathWp.push({ lat, lng });
            }
          });
          if (pathWp.length >= 2) {
            return pathWp;
          }
        }
      }

      const detalles =
        tramo.det_tramos_rutas ?? tramo.detTramosRutas ?? [];
      const path = [];
      if (Array.isArray(detalles) && detalles.length > 0) {
        const detallesOrdenados = [...detalles].sort(
          (a, b) => (a.orden || 0) - (b.orden || 0),
        );
        detallesOrdenados.forEach((detalle, dIdx) => {
          const dLatIni = parseFloat(detalle.lat_ini);
          const dLngIni = parseFloat(detalle.lon_ini);
          const dLatFin = parseFloat(detalle.lat_fin);
          const dLngFin = parseFloat(detalle.lon_fin);
          if (
            !Number.isFinite(dLatIni) ||
            !Number.isFinite(dLngIni) ||
            !Number.isFinite(dLatFin) ||
            !Number.isFinite(dLngFin)
          ) {
            return;
          }
          if (dIdx === 0) {
            path.push({ lat: dLatIni, lng: dLngIni });
          }
          path.push({ lat: dLatFin, lng: dLngFin });
        });
      }

      if (path.length >= 2) {
        return path;
      }

      const latIni = parseFloat(tramo.lat_origen ?? tramo.lat_ini ?? "");
      const lngIni = parseFloat(tramo.lng_origen ?? tramo.lon_origen ?? "");
      const latFin = parseFloat(tramo.lat_destino ?? tramo.lat_fin ?? "");
      const lngFin = parseFloat(tramo.lng_destino ?? tramo.lon_destino ?? "");
      if (
        Number.isFinite(latIni) &&
        Number.isFinite(lngIni) &&
        Number.isFinite(latFin) &&
        Number.isFinite(lngFin)
      ) {
        return [
          { lat: latIni, lng: lngIni },
          { lat: latFin, lng: lngFin },
        ];
      }
      return [];
    },

    dibujarRutasPorTramos(rutas) {
      const polylinesObj = {};

      rutas.forEach((ruta) => {
        const tramosRuta = ruta.rutas_tramos || [];

        tramosRuta.forEach((rutaTramo) => {
          const tramo = rutaTramo.tramo_ruta || rutaTramo.tramoRuta;
          if (!tramo) return;

          const path = this.pathTramoParaMapa(tramo);
          if (path.length < 2) return;

          const nombreRuta = ruta.nombre || "Ruta";
          const key = `ruta_${ruta.id}_tramo_${tramo.id}`;

          polylinesObj[key] = {
            path,
            options: {
              strokeColor: tramo.color || "#2563eb",
              strokeOpacity: 0.85,
              strokeWeight: 5,
            },
            info: this.htmlInfoVentanaTramo(nombreRuta, tramo),
          };
        });
      });

      this.$emit("update-rutas-polylines", polylinesObj);
    },

    getTipoEntidad() {
      this.listasForms.type_entidad = [
        { codigo: "null", descripcion: "Seleccione." },
        { codigo: "viaje", descripcion: "Viaje" },
        { codigo: "turno", descripcion: "Turno" },
        { codigo: "tif_turno", descripcion: "Tif Turno" },
      ];
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        axios
          .get("/api/admin/empresas/lista", {
            params: {
              lineas_negocio_id: [4, 5, 12],
              pais_id: 1,
            },
          })
          .then((response) => {
            let respuesta = response.data;
            me.listasForms.empresas = respuesta;
            loading(false);
          })
          .catch((error) => {
            me.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    selectTipoEntidad() {
      this.filter.type_entidad = null;
      if (this.type_entidad) {
        this.filter.type_entidad = this.type_entidad.codigo;
      }
    },
  },
  beforeMount() {
    this.getTipoEntidad();
  },
};
</script>
<style>
.modal .modal-dialog-aside {
  width: 440px;
  max-width: 50%;
  height: 100%;
  margin: 0;
  transform: translate(2);
  transition: transform 0.2s;
}
.modal .modal-dialog-aside .modal-content {
  height: inherit;
  border: 1;
  border-radius: 1;
}
.modal .modal-dialog-aside .modal-content .modal-body {
  overflow-y: auto;
}
.modal.fixed-left .modal-dialog-aside {
  margin-left: auto;
  transform: translateX(100%);
}
.modal.fixed-right .modal-dialog-aside {
  margin-right: auto;
  transform: translateX(-100%);
}
.modal.show .modal-dialog-aside {
  transform: translateX(0);
}
</style>
